import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { withNamespaces } from 'react-i18next';
import HtmlRender from 'components/HtmlMarkup';
import Follow from '../Follow';
import './_styles.scss';

// Note: Parts of this code is also used in Publish:
// FILE: src/modules/publish/components/Distribution/StoryCard/index.js
// If you change styling or code here, please make sure that you also update in Publish

const DATE_OPTIONS = { year: 'numeric', month: 'long', day: 'numeric' };
const VALID_TAGS = [
  'b',
  'del',
  'em',
  'i',
  'mark',
  's',
  'small',
  'span',
  'strong',
];

const summaryLengthLimit = 154;
export const truncateSummary = summary => {
  if (summary.length < summaryLengthLimit) {
    return summary;
  }

  let truncationIndex = summary.lastIndexOf('. ', summaryLengthLimit);

  if (truncationIndex > 0) {
    return summary.slice(0, truncationIndex + 1);
  }

  truncationIndex = summary.lastIndexOf(' ', summaryLengthLimit);

  if (truncationIndex > 0) {
    return `${summary.slice(0, truncationIndex)}…`;
  }

  return `${summary.slice(0, summaryLengthLimit)}…`;
};

const Teaser = ({
  className,
  toggleFollow,
  pressroomId,
  id,
  isFollowing,
  heading,
  image,
  logoUrl,
  name,
  summary,
  time,
  url,
  t,
  index,
  userLocale = 'en',
  contentLocale,
}) => (
  <div className={classnames('mnd-teaser', className)} data-index={index}>
    <div className="mnd-teaser__body">
      <div
        className={classnames('mnd-teaser__header', {
          'full-width-text': !image,
        })}
      >
        <a
          className="mnd-media-block__header"
          rel={'noopener noreferrer'}
          href={url}
          target={'_blank'}
          lang={contentLocale}
          aria-label={'Read more (opens in new window)'}
        >
          {logoUrl && (
            <div className="mnd-teaser__logo">
              <img src={logoUrl} alt={name || 'Image'} />
            </div>
          )}
          <div
            className={classnames(
              'mnd-teaser__header-description mnd-media-block',
              {
                'full-width-text': !image,
              },
            )}
          >
            <h2>
              <HtmlRender content={name} whitelistTags={VALID_TAGS} />
            </h2>
          </div>
        </a>
        {pressroomId && <Follow id={pressroomId} />}
      </div>
      <a
        href={url}
        lang={contentLocale}
        rel={'noopener noreferrer'}
        target={'_blank'}
        className="mnd-teaser__link"
        aria-label={'Read more (opens in new window)'}
      >
        {image && (
          <div className="mnd-teaser__image">
            <div className="mnd-teaser__cover">
              <div>{image}</div>
            </div>
          </div>
        )}
        <div
          className={classnames('mnd-teaser__main', {
            'full-width-text': !image,
          })}
        >
          {time && (
            <time dateTime={time}>
              {new Date(time).toLocaleDateString(userLocale, DATE_OPTIONS)}
            </time>
          )}

          <h2 className="mnd-teaser__heading">
            <HtmlRender content={heading} whitelistTags={VALID_TAGS} />
          </h2>
          {summary && (
            <p className="mnd-teaser__description">
              <HtmlRender
                content={truncateSummary(summary)}
                whitelistTags={VALID_TAGS}
              />
            </p>
          )}
        </div>
      </a>
    </div>
  </div>
);

Teaser.propTypes = {
  url: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  heading: PropTypes.string.isRequired,
  index: PropTypes.number,
  userLocale: PropTypes.string,
  contentLocale: PropTypes.string,
};

export default withNamespaces()(Teaser);
